import * as React from 'react'
import { memo } from 'react'
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5.053 22a3.256 3.256 0 0 1-2.235-.881 2.91 2.91 0 0 1-.925-2.128V5.009c0-.798.333-1.557.925-2.128A3.21 3.21 0 0 1 5.053 2h14.68c.839 0 1.635.317 2.235.881.6.564.925 1.33.925 2.128v13.982a2.95 2.95 0 0 1-.925 2.128 3.21 3.21 0 0 1-2.235.881H5.053Zm12.82-8.44h-2.219v6.983h4.08c.214 0 .426-.039.624-.117.198-.078.378-.192.53-.336.15-.144.27-.316.352-.504.082-.189.124-.391.123-.595V5.009c0-.204-.041-.406-.123-.594a1.548 1.548 0 0 0-.354-.504 1.637 1.637 0 0 0-.529-.336 1.7 1.7 0 0 0-.624-.118H5.053a1.677 1.677 0 0 0-1.152.456 1.52 1.52 0 0 0-.478 1.096v13.982c0 .411.173.805.478 1.096.306.291.72.455 1.152.456h8.157V13.56h-2.444v-2.328h2.444V9.98c0-2.371 1.212-3.414 3.284-3.414.97 0 1.492.067 1.74.1l.015.002v2.228h-1.41c-.71 0-1.046.29-1.148.874a2.725 2.725 0 0 0-.035.46v.995h2.564l-.35 2.328.004.006Z"
      clipRule="evenodd"
    />
  </svg>
)
const Memo = memo(SvgComponent)
export default Memo
